'use client';

import { useTranslations } from 'next-intl';
import { useRef, useState } from 'react';
import type { Swiper as SwiperType } from 'swiper';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import ImageWithSkeleton from '@/shared/ui/image/ImageWithSkeleton';
import { IndicatorWhite } from '@/shared/ui/svgs';

const imagePaths = ['/images/pc-main-banner.png'];

const PcMainBanner = () => {
  const t = useTranslations('main.banner');
  const [currentSlide, setCurrentSlide] = useState(0);
  const swiperRef = useRef<SwiperType>(null); // 추가
  return (
    <section className={'max-w-[1920px] mx-auto'}>
      <div className="relative w-full h-[820px] mb-[30px] px-[30px]">
        <div className="h-full rounded-[40px] overflow-hidden">
          <Swiper
            className="h-full"
            modules={[Autoplay, Navigation, Pagination]}
            spaceBetween={0}
            slidesPerView={1}
            autoplay={{
              delay: 5000,
              disableOnInteraction: false,
            }}
            speed={800} // 트랜지션 속도 (밀리초)
            loop={true}
            onSwiper={(swiper) => {
              swiperRef.current = swiper;
            }}
            onSlideChange={(swiper) => setCurrentSlide(swiper.realIndex)}
          >
            {imagePaths.map((path, index) => (
              <SwiperSlide key={index}>
                <div className="relative w-full max-w-[1860px] mx-auto h-full">
                  {/* 첫번째 이미지를 제외하고 나머지 딤처리 요청하여 딤 영역 추가... */}
                  {index > 0 && (
                    <div
                      className="absolute inset-0 z-10"
                      style={{
                        background:
                          'linear-gradient(to right, rgba(0,0,0,0.6) 0%, rgba(0,0,0,0.4) 40%, rgba(0,0,0,0.1) 100%)',
                      }}
                    ></div>
                  )}
                  <ImageWithSkeleton
                    src={path}
                    fill
                    alt={`main-banner-${index + 1}`}
                    className="object-cover"
                    quality={90}
                    priority={index === 0}
                  />
                  <div className="absolute left-[80px] top-[320px] text-white z-30">
                    <h1 className="text-[52px] font-bold mb-[16px]">{t('title')}</h1>
                    <h3 className="text-locale-28 font-medium">{t('description')}</h3>
                  </div>
                </div>
              </SwiperSlide>
            ))}

            <div className="absolute left-[80px] bottom-[60px] z-10 flex items-center gap-4">
              <div className="w-[140px] h-[4px] bg-secondary-white">
                <div
                  className="h-full bg-secondary-black transition-all duration-300"
                  style={{ width: `${(currentSlide + 1) * 20}%` }}
                ></div>
              </div>
              <div className="text-white text-locale-14">
                <span>
                  {String(currentSlide + 1).padStart(2, '0')} /{' '}
                  {String(imagePaths.length).padStart(2, '0')}
                </span>
              </div>
              <IndicatorWhite
                className="cursor-pointer"
                onClick={() => {
                  if (swiperRef.current) {
                    swiperRef.current.autoplay.running
                      ? swiperRef.current.autoplay.stop()
                      : swiperRef.current.autoplay.start();
                  }
                }}
              />
            </div>
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default PcMainBanner;
